import React, { Component } from 'react';
import { Link } from 'react-router-dom'

import '@fortawesome/fontawesome'
import '@fortawesome/fontawesome-free-solid'
import '@fortawesome/fontawesome-free-regular'
import '@fortawesome/fontawesome-free-brands'

class Header extends Component {
  render() {
    return (
      <div className="Header">
        <div className="Header-title-box">
          <Link to={`/`} className="Header-title">観光スポットスタンプラリー</Link>
        </div>
        <div className="Header-nav-links">
          <Link to={`/`} className={`Header-nav-button`}>
            <i className="fas fa-home"></i>
          </Link>
          <Link to={`/search`} className={`Header-nav-button`}>
            <i className="fas fa-search"></i>
          </Link>
          <Link to={`/mypage`} className={`Header-nav-button`}>
            <i className="fas fa-user-circle"></i>
          </Link>
        </div>
      </div>
    );
  }
}

export default Header;


// <FontAwesomeIcon className="HomeTab-icon" icon="home" />
// <FontAwesomeIcon className="OrderListTab-icon" icon="list" />
// <FontAwesomeIcon className="SearchTab-icon" icon="search" />
